import { AbstractModel } from '@patsnap/tahiti-core';
import type { CreditModel } from '../credit-model';
import type { CreditData, CreditUsageKey } from '../../types';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

@injectable()
export class CreditModelImpl extends AbstractModel<CreditData> implements CreditModel {
    protected _modelData: CreditData = {
        remainingNoveltySearchTimes: 0,
        remainingFtoSearchTimes: 0,
        remainingPatentDisclosureTimes: 0,
        remainingTranslationTimes: 0,
        remainingCnPatentSpecificationTimes: 0,
        remainingUsPatentSpecificationTimes: 0,
        remainingEuPatentSpecificationTimes: 0,
        usages: new Map<CreditUsageKey, {
            usage: number;
            total: number;
        }>(),
    };
}
